export const CITIZEN_PROFILE_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'dashboard',
  'unified_person',
  'identity_card',
  'family',
  'public_agent_module_permission',
  'group_module_permission',
]
